"use strict";

var NamedNode = require('./named-node');

function Namespace(nsuri) {
  NamedNode.find(nsuri);
  var mem = {};
  return function (ln) {
    if (mem[ln]) {
      return mem[ln];
    }

    var fullIRI = nsuri + (ln || '');
    return mem[ln] = NamedNode.find(fullIRI, ln);
  };
}

module.exports = Namespace;